/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useMutation
} from '@tanstack/react-query'
import type {
  UseMutationOptions,
  MutationFunction
} from '@tanstack/react-query'
import type {
  PostDepositFiatResponse,
  PostDepositFiatRequest
} from './schema'



export const utxDepositFiatPostDepositFiatRequest = (
    postDepositFiatRequest: PostDepositFiatRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostDepositFiatResponse>> => {
    return axios.post(
      `/deposit`,
      postDepositFiatRequest,options
    );
  }



    export type UtxDepositFiatPostDepositFiatRequestMutationResult = NonNullable<Awaited<ReturnType<typeof utxDepositFiatPostDepositFiatRequest>>>
    export type UtxDepositFiatPostDepositFiatRequestMutationBody = PostDepositFiatRequest
    export type UtxDepositFiatPostDepositFiatRequestMutationError = AxiosError<unknown>

    export const useUtxDepositFiatPostDepositFiatRequest = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxDepositFiatPostDepositFiatRequest>>, TError,{data: PostDepositFiatRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxDepositFiatPostDepositFiatRequest>>, {data: PostDepositFiatRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxDepositFiatPostDepositFiatRequest(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxDepositFiatPostDepositFiatRequest>>, TError, {data: PostDepositFiatRequest}, TContext>(mutationFn, mutationOptions)
    }
    